document.addEventListener("DOMContentLoaded", function () {

  const input = document.getElementById("hc-search-input");
  const box   = document.getElementById("hc-search-results");
  const clear = document.getElementById("hc-search-clear");

  if (!input || !box) return;

  const articles = window.HC_ARTICLES || [];

  input.addEventListener("input", function () {
    const q = this.value.trim().toLowerCase();

    if (!q) {
      box.style.display = "none";
      clear.style.display = "none";
      box.innerHTML = "";
      return;
    }

    clear.style.display = "block";

    const matches = articles
      .filter(a => a.title.toLowerCase().includes(q))
      .slice(0, 6);

    let html = "";

    if (!matches.length) {
      html = `<div class="hc-search-empty">No results found</div>`;
    } else {
      matches.forEach(a => {
        html += `
          <a class="hc-search-item" href="${a.url}">
            <div class="hc-search-icon">📄</div>
            <div class="hc-search-text">
              <strong>${a.title}</strong>
              <small>${a.category}</small>
            </div>
          </a>
        `;
      });
    }

    box.innerHTML = html;
    box.style.display = "block";
  });

  clear.addEventListener("click", function () {
    input.value = "";
    box.innerHTML = "";
    box.style.display = "none";
    clear.style.display = "none";
  });
});
